

export default function HandCheck() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
    >
      <path
        d="M1.92006 3.56018H0.64002C0.286729 3.56018 0 3.75123 0 3.98739V10.8142C0 11.0494 0.286729 11.2404 0.64002 11.2404H1.92006C2.27335 11.2404 2.56008 11.0494 2.56008 10.8132V3.98643C2.56008 3.75123 2.27335 3.56018 1.92006 3.56018Z"
        fill="#161613"
      />
      <path
        d="M10.4462 10.19C10.4462 9.95097 10.3866 9.72544 10.2815 9.52751C10.6581 9.27232 10.9057 8.84094 10.9057 8.35196C10.9057 8.11257 10.8464 7.88698 10.7416 7.68911C11.1179 7.43387 11.3652 7.00268 11.3652 6.51396C11.3652 6.36811 11.3432 6.2274 11.3023 6.09495H14.0818C14.8633 6.09495 15.5008 5.45754 15.5008 4.67595C15.5008 3.89435 14.8633 3.25694 14.0818 3.25694H8.70373L8.98679 3.03179C9.61071 2.54701 9.70937 1.65176 9.21681 1.04119C8.73502 0.423294 7.84836 0.320604 7.23789 0.804966L2.76642 3.94416L2.55371 4.09349V4.35338V10.4721V10.6598L2.6772 10.8011C3.10105 11.2862 3.72517 11.609 4.43222 11.609H9.02723C9.80883 11.609 10.4462 10.9716 10.4462 10.19Z"
        stroke="#161613"
      />
    </svg>
  );
}
